import { useTheme } from '@mui/material/styles';
import {
  type GridColDef,
  type GridEventListener,
  type GridRowsProp,
} from '@mui/x-data-grid';
import { lazy } from 'react';
import Suspense from '../Suspense';

const MUIDataGrid = lazy(() =>
  import('@mui/x-data-grid').then((module) => ({
    default: module.DataGrid,
  }))
);

interface DatagridProps {
  columns: GridColDef[];
  rows: GridRowsProp;
  onRowClick?: GridEventListener<'rowClick'>;
}

function Datagrid({ columns, rows, onRowClick }: DatagridProps) {
  const theme = useTheme();

  return (
    <Suspense>
      <MUIDataGrid
        columns={columns}
        rows={rows}
        onRowClick={onRowClick}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        sx={{
          backgroundColor: 'transparent',
          border: `1px solid ${theme.palette.primary['01']}`, // borda externa do grid
          borderRadius: '12px',
          fontSize: '14px',
          cursor: 'pointer',
          width: '100%',
          maxWidth: '100%',

          // cabeçalhos
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: theme.palette.primary['01'],
            color: '#FFFFFF',
            border: `1px solid ${theme.palette.primary['01']}`,
          },

          '& .MuiDataGrid-columnHeaders': {
            borderBottom: `1px solid #00cfff45`,
          },

          // células
          '& .MuiDataGrid-cell': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'flex',
            alignItems: 'center',
            borderRight: `1px solid #00cfff45`,
          },

          // linhas
          '& .MuiDataGrid-row': {
            borderBottom: `1px solid #00cfff45`,
          },

          // remove última borda de coluna
          '& .MuiDataGrid-columnHeader:last-of-type, & .MuiDataGrid-cell:last-of-type':
            {
              borderRight: 'none',
            },
        }}
        disableMultipleRowSelection
        disableRowSelectionOnClick
        disableEval
      />
    </Suspense>
  );
}

export default Datagrid;
